import * as R from 'ramda'
import React, { useCallback } from 'react'
import { IconButton, Stack, styled, Typography } from '@mui/material'
import { Message } from '@weblite/ts-action/message'
import { CloseIcon, EyeIcon, ForwardIcon, RemoveIcon } from '$common/icons'
import { showDeleteMessageModal } from '$comp/modals/confirmation-dialog'
import { useCanDeleteMessages } from '$logic/message/react-hook'
import { openForwardListHandler } from '$logic/message'
import { openRoom } from '$logic/opened-room'
import { toLocale } from '$func/text'

const ACTIONS_SPACING = 1

const StyledStack = styled(Stack)(({ theme }) => ({
  height: '45px',
  backgroundColor: theme.palette.white,
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0 7px',
}))

const StyledTypography = styled(Typography)`
  margin-right: 16px;
  align-self: center;
`

interface Props {
  roomId: string
  messages: Message[]
  onBack: () => void
}

export function SelectionBar({ roomId, messages, onBack }: Props) {
  const iids = R.pluck('iid', messages)

  const onSee = useCallback(async () => openRoom(roomId, iids[0]), [iids])
  const onRemove = useCallback(() => showDeleteMessageModal(roomId, iids), [
    iids,
  ])
  const onForward = useCallback(
    () =>
      openForwardListHandler(
        roomId,
        R.reverse(iids),
        'SHARED_MEDIA_SELECTION_BAR',
      ),
    [iids],
  )

  const canDelete = useCanDeleteMessages(messages)

  if (!(messages && messages.length)) return null
  return (
    <StyledStack direction="row">
      <Stack direction="row">
        <IconButton onClick={onBack}>
          <CloseIcon sx={{ color: 'gray' }} />
        </IconButton>
        <StyledTypography>{toLocale(iids.length)}</StyledTypography>
      </Stack>

      <Stack
        direction="row"
        spacing={ACTIONS_SPACING}
        sx={{ direction: 'ltr' }}
      >
        <IconButton onClick={onForward}>
          <ForwardIcon sx={{ color: 'secondary.main' }} />
        </IconButton>

        {canDelete && (
          <IconButton onClick={onRemove}>
            <RemoveIcon />
          </IconButton>
        )}

        {iids.length === 1 && (
          <IconButton onClick={onSee}>
            <EyeIcon />
          </IconButton>
        )}
      </Stack>
    </StyledStack>
  )
}
